<div class="container-xxl flex-grow-1 container-p-y">
  <div class="row mb-6 gy-6">
    <div class="col-xl">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center bg-light">
          <h4 class="mb-0">Notifications</h4>
        </div>

        <div class="card-header pl-2">
          <h5 class="mb-0 fw-3">Send a new notification</h5>
        </div>

        <div class="card-body border rounded-3 p-3">
          <form [formGroup]="entityForm" (ngSubmit)="onSubmit()">

            <!-- Role Dropdown -->
            <div class="mb-3 position-relative">
              <label class="form-label">Notification To</label>
              
              <!-- Input field to show selected tags -->
              <div class="form-control cursor-pointer" (click)="toggleDropdown()">
                
                <span *ngIf="selectedTags.length === 0" class="text-muted">Select Tags</span>
                <span *ngFor="let tag of selectedTags ; let i = index" class="badge btnn" [class.ml-1]="i !== 0"
                style="background-color: #106048; padding: 5px 10px; border-radius: 5px;">
                  {{ tag.title }} <span (click)="removeTag(tag)" style="cursor: pointer;">×</span>
                </span>
              </div>
            
              <!-- Custom dropdown with checkboxes -->
              <div class="dropdown position-absolute w-100">
                <div class="dropdown-menu show w-100 border rounded shadow-sm p-2" 
                     *ngIf="dropdownOpen"
                     >
                  
                  <div class="form-check pb-1"  *ngFor="let tag of Roles">
                    <input type="checkbox" class="form-check-input" 
                           [id]="'tag_' + tag.id"
                           [checked]="isSelected(tag)" 
                           (change)="toggleTag(tag)"
                           >
                    <label class="form-check-label ms-1" [for]="'tag_' + tag.id">
                      {{ tag.title }}
                    </label>
                    

                  </div>
                </div>
              </div>
            </div>
            

            <div formGroupName="title">

              <!-- Ttile in English -->
              <div class="mb-3">
                <label class="form-label" for="fullName">Notification title <small
                    class="text-muted">(English)</small></label>
                <input type="text" class="form-control" id="enTitle" formControlName="en"
                  [class.error]="entityForm.get('title.en').invalid && entityForm.get('title.en').touched"
                  placeholder="Notification Header(EN)" />
                <span class="text-danger">
                  <span *ngIf="entityForm.get('title.en').invalid && entityForm.get('title.en').touched">
                    <span *ngIf="entityForm.get('title.en').errors?.['required']"><small>Title is
                        required.</small></span>
                    <span *ngIf="entityForm.get('title.en').errors?.['minlength']"><small>Title must be at least 3
                        characters.</small></span>
                  </span>
                </span>
              </div>

              <!-- Ttile in Arabic -->
              <div class="mb-3">
                <label class="form-label" for="fullName">Notification Title <small
                    class="text-muted">(Arabic)</small></label>
                <input type="text" class="form-control" id="arTitle" formControlName="ar"
                  [class.error]="entityForm.get('title.ar').invalid && entityForm.get('title.ar').touched"
                  placeholder="Notification Header(AR)" />
                <span>
                  <span *ngIf="entityForm.get('title.ar').invalid && entityForm.get('title.ar').touched">
                    <span *ngIf="entityForm.get('title.ar').errors?.['required']"><small>Title is
                        required.</small></span>
                    <span *ngIf="entityForm.get('title.ar').errors?.['minlength']"><small>Title must be at least 3
                        characters.</small></span>
                  </span>
                </span>
              </div>
            </div>


            <!-- Notification Body in both english and arabic -->
            <div formGroupName="body">
              <div class="mb-3">
                <label class="form-label" for="ENmessage">Notification Content <small>(English)</small></label>
                <textarea class="form-control" id="ENmessage" formControlName="en" rows="2"
                  [class.error]="entityForm.get('body.en').invalid && entityForm.get('body.en').touched"
                  placeholder="Notification body (English)"></textarea>
                <span class="text-danger">
                  <span *ngIf="entityForm.get('body.en').invalid && entityForm.get('body.en').touched">
                    <span *ngIf="entityForm.get('body.en').errors?.['required']"><small>Information is
                        required.</small></span>
                  </span>
                </span>
              </div>

              <div class="mb-3">
                <label class="form-label" for="ARmessage">Notification Content <small
                    class="text-muted">(Arabic)</small></label>
                <textarea class="form-control" id="ARmessage" formControlName="ar" rows="2"
                  [class.error]="entityForm.get('body.ar').invalid && entityForm.get('body.ar').touched"
                  placeholder="Notification body (Arabic)"></textarea>
                <span class="text-danger">
                  <span *ngIf="entityForm.get('body.ar').invalid && entityForm.get('body.ar').touched">
                    <span *ngIf="entityForm.get('body.ar').errors?.['required']"><small>Information is
                        required.</small></span>
                  </span>
                </span>
              </div>
            </div>
            <div class="d-flex justify-content-center">
              <button type="submit" class="btn btnn">SEND NOTIFICATION <i class="bi bi-bell-fill"></i></button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>